export default __webpack_public_path__ + "static/char-s-34-ko-853c112ee9199f66ce5c507c01ca6622.webp";